import {
  useGetAssignmentMarkQuery,
  useGetQuizMarkQuery,
  useGetUsersQuery,
} from "../../../features/leaderboard/leaderboardApi";
import UserOwnRank from "./UserOwnRank";
import SingleRank from "./SingleRank";
import { useSelector } from "react-redux";

export default function TopRank() {
  const { data: users, isLoading, isError } = useGetUsersQuery();
  const { data: assignmentMark } = useGetAssignmentMarkQuery();
  const { data: quizMark } = useGetQuizMarkQuery();

  const loginUser = useSelector((state) => state.auth);

  let top20result = [];

  if (users && assignmentMark && quizMark) {
    const results = users.map(function (user) {
      const assignmentMarkTotal = assignmentMark
        .map(
          (assignment) => assignment.student_id === user.id && assignment.mark
        )
        .reduce((a, b) => Number(a) + Number(b), 0);
      const quizeMarkTotal = quizMark
        .map((quize) => quize.student_id === user.id && quize.mark)
        .reduce((a, b) => Number(a) + Number(b), 0);
      return {
        id: user.id,
        name: user.name,
        assignmentmark: assignmentMarkTotal,
        quizemark: quizeMarkTotal,
        total: assignmentMarkTotal + quizeMarkTotal,
      };
    });
    results.sort((a, b) => b.total - a.total);

    var rank = 1;
    for (var i = 0; i < results.length; i++) {
      if (i > 0 && results[i].total < results[i - 1].total) {
        rank++;
      }
      results[i].rank = rank;
    }
    top20result = results;
  }

  let content = null;
  if (isLoading)
    content = (
      <tr className="border-b border-slate-600/50">
        <td colSpan={"5"} className="table-td text-center">
          Loading...
        </td>
      </tr>
    );
  if (!isLoading && isError)
    content = (
      <tr className="border-b border-slate-600/50">
        <td colSpan={"5"} className="table-td text-center">
          Error
        </td>
      </tr>
    );
  if (
    !isLoading &&
    !isError &&
    users?.length > 0 &&
    assignmentMark?.length > 0 &&
    quizMark?.length > 0
  )
    content = top20result
      .filter((rank) => rank.rank <= 20)
      .map((user, i) => <SingleRank key={i} user={user} />);

  let ownrank = null;

  if (top20result?.length > 0)
    ownrank = top20result.filter((item) => item.id === loginUser.user.id);

  return (
    <>
      {ownrank && <UserOwnRank ownrank={ownrank} />}
      <div className="my-8">
        <h3 className="text-lg font-bold">Top 20 Result</h3>
        <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
          <thead>
            <tr className="border-b border-slate-600/50">
              <th className="table-th !text-center">Rank</th>
              <th className="table-th">Name</th>
              <th className="table-th !text-center">Quiz Mark</th>
              <th className="table-th !text-center">Assignment Mark</th>
              <th className="table-th !text-center">Total</th>
            </tr>
          </thead>

          <tbody>{content}</tbody>
        </table>
      </div>
    </>
  );
}
